import type { Reducer } from 'redux';

import type { ClientAttachmentSettingsBootstrapAction } from '../../domains/clientAttachmentSettings/actions.types';

import type { ClientAttachmentSettings } from './types';

export type ClientAttachmentSettingsAction = ClientAttachmentSettingsBootstrapAction;

const initialState: ClientAttachmentSettings = {
  attachmentsDisabled: false,
};

const reducer: Reducer<ClientAttachmentSettings, ClientAttachmentSettingsAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'CLIENT_ATTACHMENT_SETTINGS.BOOTSTRAP':
      return {
        ...state,
        ...action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
